import React, {useContext, useEffect, useState} from "react";
import PagedList from "../common/PagedList";
import axios from "../common/axios";
import {Checkbox} from "antd";
import {BrandContext} from "../common/BrandContext";
import {ContentContext} from "../common/ContentContext";

const MyClasses = props => {
    const {updateActiveClass, loadAllClasses, callback} = props;
    const brandConfig = useContext(BrandContext);
    const {setContentLoading} = useContext(ContentContext);
    const [classes, setClasses] = useState([]);
    const [listLoading, setListLoading] = useState(true);
    const columns = [
        {title: 'Class name', dataIndex: 'className', key: 'className'},
        {title: 'Class Key', dataIndex: 'classKey', key: 'classKey'},
        {title: 'Students', dataIndex: 'students', key: 'students'},
        {title: 'Teachers', dataIndex: 'teachers', key: 'teachers'},
        {title: 'School Year', dataIndex: 'schoolYear', key: 'schoolYear'},
        {title: 'Total Usage (h:mm:s)', dataIndex: 'totalUsage', key: 'totalUsage', ellipsis: true}
    ]
    if (brandConfig.allowHideWorkspaces) columns.push({title: 'Hide Workspaces', dataIndex: 'hideWorkspaces', key: 'hideWorkspaces', ellipsis: true});
    if (!brandConfig.hideClassShowSolutions) columns.push({title: 'Show Answers / Suggested Responses', dataIndex: 'responses', key: 'responses', ellipsis: true});
    if (!brandConfig.hideClassShowWorkedSolutions) columns.push({title: 'Show Worked Solutions', dataIndex: 'solutions', key: 'solutions', ellipsis: true});
    if (brandConfig.showClassCalculatorOptions) {
        columns.push({title: 'Show Casio ClassPad', dataIndex: 'casio', key: 'casio', ellipsis: true});
        columns.push({title: 'Show TI-Nspire', dataIndex: 'ti', key: 'ti', ellipsis: true});
    }

    const handleLinkToAllClasses = () => {
        loadAllClasses();
    }

    function updateClasses(classId, newValues) {
        let newClassValues;
        classes.map(clazz => {
            if (clazz.classId === classId) newClassValues = { ...clazz, ...newValues };
        });

        setContentLoading(true);
        axios.post('/web/ui/myClasses/updateClass', newClassValues,{headers: {'Content-Type': 'application/json'}})
            .then(response => {
                if (response.data) {
                    setClasses(prevClasses => {
                        return prevClasses.map(clazz => {
                            if (clazz.classId === classId) return response.data;
                            return clazz;
                        });
                    });
                }
            }).finally(() => {
                setContentLoading(false);
            });
    }

    useEffect(() => {
        setListLoading(true);
        axios.get('/web/ui/myClasses/viewMyClasses')
            .then(response => {
                setClasses(response.data.map(clazz => {
                    return clazz
                }));
                setListLoading(false);
            }).finally(() => {
                setContentLoading(false);
            });
        if (callback && typeof callback === 'function') callback();
    }, []);

    const dataSource = classes.map(clazz => {
        let newRow = {
            key: clazz.classId,
            className: <a onClick={() => updateActiveClass(clazz)}>{clazz.className}</a>,
            classKey: clazz.classCode,
            students: clazz.totalStudents,
            teachers: clazz.totalTeachers,
            schoolYear: clazz.calendarYear,
            totalUsage: clazz.totalStudentUsage
        }
        if (brandConfig.allowHideWorkspaces) newRow.hideWorkspaces = <Checkbox
            className='flexCentre'
            checked={clazz.hideWorkspaces}
            onChange={event => updateClasses(clazz.classId, {hideWorkspaces: event.target.checked})}
        ><span className="ch-accessibility-label">Hide workspaces</span></Checkbox>
        if (!brandConfig.hideClassShowSolutions) newRow.responses = <Checkbox
            className='flexCentre'
            checked={clazz.showSolutions}
            onChange={event => updateClasses(clazz.classId, {showSolutions: event.target.checked})}
        ><span className="ch-accessibility-label">Show answers</span></Checkbox>
        if (!brandConfig.hideClassShowWorkedSolutions) newRow.solutions = <Checkbox
            className='flexCentre'
            checked={clazz.showWorkedSolutions}
            onChange={event => updateClasses(clazz.classId, {showWorkedSolutions: event.target.checked})}
        ><span className="ch-accessibility-label">Show worked solutions</span></Checkbox>
        if (brandConfig.showClassCalculatorOptions) {
            newRow.casio = <Checkbox
                className='flexCentre'
                checked={clazz.showCalculatorCasio}
                onChange={event => updateClasses(clazz.classId, {showCalculatorCasio: event.target.checked})}
            ><span className="ch-accessibility-label">Show Casio calculator</span></Checkbox>
            newRow.ti = <Checkbox
                className='flexCentre'
                checked={clazz.showCalculatorTi}
                onChange={event => updateClasses(clazz.classId, {showCalculatorTi: event.target.checked})}
            ><span className="ch-accessibility-label">Show TI calculator</span></Checkbox>
        }
        return newRow;
    });

    return (
        <>
            <p className="padding--rm">Select your classes from <a onClick={handleLinkToAllClasses}>All Classes</a>.</p>
            <PagedList className="margin-t--l" columns={columns} dataSource={dataSource} loading={listLoading} size={"small"} pagination={false}/>
        </>
    )
}

export default MyClasses;